import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { getUserAvatarSrc } from '../User/helpers';
import AvatarImage from '../User/AvatarImage';

import s from './GroupCard.scss';

export interface Props {
  group: PapiUser;
  className?: string;
  biData?: BiEvent;
  path?: string;
  anchor?: boolean;
}

const GroupCard: React.FC<Props> = ({
  group,
  className,
  biData,
  path,
  anchor,
}) => {
  const { t } = useTranslation();
  return (
    <BiLink
      href={Url.userLink(group.username, path, anchor)}
      className={classnames(s['root'], 'ds-card', className)}
      biData={biData}
    >
      <div className={s['img-wrap']}>
        <AvatarImage
          alt={t('avatar.alt', {
            username: group.username || t('avatar.unknownUser'),
          })}
          isGroup={true}
          enableLazyLoad={true}
          src={getUserAvatarSrc(group) ?? undefined}
        />
      </div>
      <div className={s['name']}>{group.username}</div>
    </BiLink>
  );
};
GroupCard.displayName = 'GroupCard';

export default GroupCard;
